// ================================================================================
// recruit.js
// 採用情報用のスクリプトファイル
// ================================================================================

// DOM Read for Vanilla
// --------------------------------------------------------------- //

document.addEventListener('DOMContentLoaded', () => {

	// 採用情報
	// --------------------------------------------------------------- //

	if ( document.getElementById('js-recruit-visual') ) {
		document.getElementById('js-recruit-visual-first').classList.add('is-first')
		document.getElementById('js-recruit-visual-second').classList.add('is-second')
	}


} );
